<template>
  <div class="bg">
    <div class="head-list">
      <div v-for="(item, index) in headList" :key="index">
        <div class="num">{{ item.value }}</div>
        <div class="text">{{ item.name }}{{ item.unit }}</div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-70">
        <div class="tips">
          月报关统计
        </div>
        <div id="bg-charts1"></div>
      </div>
      <div class="content w-30">
        <div class="tips">
          申报方式占比
        </div>
        <div id="bg-charts2"></div>
      </div>
    </div>
    <div class="line1 line2">
      <div class="content w-100">
        <div class="tips">
          报关单据明细
        </div>
        <div class="table">
          <el-tabs class="el-tab" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in tableLit"
              :key="index"
              :label="item.label"
              :name="item.name"
            >
            </el-tab-pane>
          </el-tabs>
          <div class="search">
            <el-input
              placeholder="请输入系统唯一序号"
              suffix-icon="el-icon-search"
              v-model="guid"
              @change="handleGuid"
            >
            </el-input>
            <div class="reset" @click="reset">
              重置
            </div>
          </div>
          <tableLit
            ref="tableLitRef"
            :info="info"
            :guid="guid"
            :activeName="activeName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
import tableLit from './components/tableLit.vue'
// const customsStatusJson = {
//   '1': '已清关',
//   '2': '待清关',
//   '3': '清关中'
// }
const { mapState, mapMutations } = require('vuex')
export default {
  components: { pagination, tableLit },
  props: ['info'],
  data () {
    return {
      tableData: [{}],
      guid: '',
      activeName: 'Order',
      tableLit: [
        {
          label: '订单申报',
          name: 'Order'
        },
        {
          label: '收款单申报',
          name: 'Receipt'
        },
        {
          label: '运单申报',
          name: 'Waybill'
        },
        {
          label: '清单申报',
          name: 'Manifest'
        },
        {
          label: '清单总分单申报',
          name: 'ListTotal'
        },
        {
          label: '运抵单申报',
          name: 'DeclarationNote'
        },
        {
          label: '离境单申报',
          name: 'DeclarationDeparture'
        },
        {
          label: '汇总单申报',
          name: 'summarySheet'
        }
      ],
      headList: [],
      summary: {},
      declarationMonthStatistics: [],
      declarationTradeMode9610Summary: [],
      declarationTradeMode9810Summary: []
    }
  },

  computed: {
    ...mapState({
      searchDate: state => {
        return state.home.searchDate
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
  },

  mounted () {
    this.init()
    this.initCharts1()
    this.initCharts2()
  },

  methods: {
    reset () {
      this.guid = ''
      this.$nextTick(() => {
        this.$refs.tableLitRef.getlist()
      })
    },
    handleGuid () {
      this.$refs.tableLitRef.getlist()
    },
    handleClick (tab, event) {
      this.guid = ''
      this.activeName = tab.name
    },
    ...mapMutations({}),
    init () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.bg.getDeclarationEnterpriseData}`,
        data: {
          // searchDate: this.searchDate,
          customerNo: this.info.customerNo
          // 'companyName': this.info.companyName
          // 'guid': this.info.guid.officeId
        }
      }).then(res => {
        if (res.data) {
          const dataInfo = res.data
          this.summary = dataInfo
          // this.declarationMonthStatistics =
          //   res.data.declarationMonthStatistics || []
          // this.declarationTradeMode9610Summary =
          //   res.data.declarationTradeMode9610Summary || []
          // this.declarationTradeMode9810Summary =
          //   res.data.declarationTradeMode9810Summary || []
          this.headList = [
            {
              name: '已申报数量',
              value: dataInfo.declaredNum || '0',
              unit: '（单）'
            },
            {
              name: '已结关数量',
              value: dataInfo.clearanceNum || '0',
              unit: '（单）'
            },
            {
              name: '申报商品总金额',
              value: dataInfo.totalPrice || '0',
              unit: 'USD'
            },
            {
              name: '',
              value: dataInfo.declaredWeight || '0',
              unit: '申报商品重量kg'
            }
          ]
          // this.initCharts1()
          // this.initCharts2()
        }
      })
    },
    setMonthData (list, key, getKey) {
      let data2 = []
      for (let i = 0; i < 12; i++) {
        let monthNum = i + 1 <= 9 ? ('0' + (i + 1)) : i + 1
        for (let e of list) {
          if (!e[key].includes(monthNum)) continue
          data2[i] = e[getKey]
        }
        if (!data2[i]) {
          data2[i] = 0
        }
      }
      return data2
    },
    initCharts1 () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.bg.getDeclarationMonthlyStatistics}`,
        data: {
          // searchDate: this.searchDate,
          customerNo: this.info.customerNo
          // 'companyName': this.info.companyName
          // 'guid': this.info.guid.officeId
        }
      }).then(res => {
        if (res.data) {
          const dataInfo = res.data
          var chartDom = document.getElementById('bg-charts1')
          var myChart = this.$echarts.init(chartDom)
          let data2 = this.setMonthData(dataInfo, 'declarationDate', 'declaredNum')
          let option
          option = {
            legend: {
              data: ['申报数量'],
              icon: 'circle',
              right: '10%',
              textStyle: {
                color: '#fff'
              }
            },
            xAxis: {
              type: 'category',
              data: [
                '1月',
                '2月',
                '3月',
                '4月',
                '5月',
                '6月',
                '7月',
                '8月',
                '9月',
                '10月',
                '11月',
                '12月'
              ],
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: 'rgba(227, 242, 252, 0.39)',
                  width: 45,
                  type: 'solid'
                },
                z: 0 // 注意要设置层级，不然会在覆盖在柱子前面，设置为0就在柱子后面显示了。
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            series: [
              {
                name: '申报数量',
                data: data2,
                type: 'line',
                smooth: true,
                areaStyle: {
                  textStyle: {
                    color: '#fff'
                  }
                }
              }
            ],
            grid: {
              left: 0,
              right: 0,
              bottom: 0,
              top: 67,
              containLabel: true
            }
          }
          option && myChart.setOption(option)
        }
      })
    },
    initCharts2 () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.bg.getDeclarationTypeProportion}`,
        data: {
          // searchDate: this.searchDate,
          customerNo: this.info.customerNo
          // 'companyName': this.info.companyName
          // 'guid': this.info.guid.officeId
        }
      }).then(res => {
        if (res.data) {
          const dataInfo = res.data
          let curOrderType = []
          res.data.forEach(item => {
            curOrderType.push(item[0].orderType)
          })
          const dataObj = {
            '9610': [],
            '9810': [],
            '9710': [],
            '1210': []
          }
          for (let e of dataInfo) {
            for (let i of e) {
              if (!curOrderType.includes(i.orderType)) continue
              dataObj[i.orderType] = this.setMonthData(e, 'declarationDate', 'typeNum')
            }
          }
          console.log('dataObj', dataObj)
          var chartDom = document.getElementById('bg-charts2')
          var myChart = this.$echarts.init(chartDom)
          const colors = ['#6295f6', '#51b2bb', '#51b2bb', '#51b2bb']
          let option
          option = {
            colors,
            legend: {
              data: curOrderType,
              icon: 'circle',
              right: '40%',
              textStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: 'rgba(227, 242, 252, 0.39)',
                  width: 50,
                  type: 'solid'
                },
                z: 0 // 注意要设置层级，不然会在覆盖在柱子前面，设置为0就在柱子后面显示了。
              }
            },
            xAxis: {
              type: 'category',
              data: [
                '1月',
                '2月',
                '3月',
                '4月',
                '5月',
                '6月',
                '7月',
                '8月',
                '9月',
                '10月',
                '11月',
                '12月'
              ],
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            grid: {
              left: 0,
              right: 0,
              bottom: 0,
              top: 67,
              containLabel: true
            },
            series: [
              {
                data: dataObj['9610'],
                type: 'bar',
                name: '9610',
                barWidth: 10,
                // showBackground: false,
                // backgroundStyle: {
                //   color: rgba(116,142,135,0.2)
                // },
                itemStyle: {
                  normal: {
                    color: function (parmas) {
                      let colorList = [
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6'
                      ]
                      return colorList[parmas.dataIndex]
                    }
                  }
                },
                label: {
                  // 柱图头部显示值
                  show: false,
                  position: 'top',
                  color: '#ffffff',
                  fontSize: '10px',
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 12
                  }
                }
              },
              {
                data: dataObj['9810'],
                type: 'bar',
                name: '9810',
                barWidth: 10,
                // showBackground: false,
                // backgroundStyle: {
                //   color: rgba(116,142,135,0.2)
                // },
                itemStyle: {
                  normal: {
                    color: function (parmas) {
                      let colorList = [
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6'
                      ]
                      return colorList[parmas.dataIndex]
                    }
                  }
                },
                label: {
                  // 柱图头部显示值
                  show: false,
                  position: 'top',
                  color: '#ffffff',
                  fontSize: '10px',
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 12
                  }
                }
              },
              {
                data: dataObj['9710'],
                type: 'bar',
                name: '9710',
                barWidth: 10,
                // showBackground: false,
                // backgroundStyle: {
                //   color: rgba(116,142,135,0.2)
                // },
                itemStyle: {
                  normal: {
                    color: function (parmas) {
                      let colorList = [
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6',
                        '#6295f6'
                      ]
                      return colorList[parmas.dataIndex]
                    }
                  }
                },
                label: {
                  // 柱图头部显示值
                  show: false,
                  position: 'top',
                  color: '#ffffff',
                  fontSize: '10px',
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 12
                  }
                }
              },
              {
                data: dataObj['1210'],
                type: 'bar',
                name: '1210',
                barWidth: 10,
                // showBackground: false,
                // backgroundStyle: {
                //   color: rgba(116,142,135,0.2)
                // },
                itemStyle: {
                  normal: {
                    // color: function (parmas) {
                    //   let colorList = [
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6',
                    //     '#6295f6'
                    //   ]
                    //   return colorList[parmas.dataIndex]
                    // }
                  }
                },
                label: {
                  // 柱图头部显示值
                  show: false,
                  position: 'top',
                  color: '#ffffff',
                  fontSize: '10px',
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 12
                  }
                }
              }
            ]
          }
          option && myChart.setOption(option)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  .head-list {
    display: flex;
    margin-top: 30px;
    margin-bottom: 24px;
    justify-content: space-between;
    padding: 0 150px;
    color: #fff;
    font-size: 24px;
    .num {
      color: rgb(71, 166, 234);
      font-size: 24px;
      line-height: 40px;
      text-align: center;
    }
    .text {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .table {
    margin-top: 55px;
  }
  .search {
    margin: 20px 0px 0px;
    font-size: 14px;
    width: 325px;
    display: flex;
    el-input {
      border-radius: 40px;
    }
    .reset {
      width: 50px;
      margin-left: 10px;
      color: #519bec;
    }
  }
  .content {
    border: 1px solid rgb(71, 166, 234);
    border-radius: 6px;
    padding: 16px 20px 32px 20px;
    margin: 0 16px 16px 16px;
    .top {
      display: flex;
      font-size: 18px;
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        background: rgb(71, 166, 234);
        margin-right: 16px;
      }
    }
    .tips {
      position: absolute;
      top: 20px;
      left: 20px;
      width: 198px;
      height: 43px;
      line-height: 43px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(3, 196, 219, 0.16) 100%
      );
      border-left: 2px solid #fff;
      font-size: 20px;
      padding-left: 13px;
    }
    .title {
      text-align: center;
      font-size: 18px;
    }
  }
  .line1 {
    display: flex;
    height: 440px;
    margin-bottom: 72px;
    margin-left: 20px;
  }
  .line2 {
    height: 644px;
  }
  .w-70 {
    position: relative;
    width: 826px;
    height: 100%;
    // margin-right:20px;
    // margin-left:32px;
  }
  .w-30 {
    position: relative;
    width: 826px;
    height: 100%;
    // margin-left:32px;
  }
  .w-100 {
    position: relative;
    width: calc(100% - 20px);
  }
  #bg-charts1 {
    margin-top: 16px;
    width: 100%;
    height: 400px;
  }
  #bg-charts2 {
    width: 100%;
    height: 400px;
    margin-top: 16px;
  }
  #bg-charts3 {
    width: 100%;
    height: 400px;
    margin-top: 40px;
  }
  .el-tab {
    margin: 0px 0px;
  }
}
</style>
<style>
.el-tabs__nav-wrap::after {
  background-color: #000834;
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/bg.vue